import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button, TrevorComponent } from '@trevor/ui-components';
import style from '@/css/module/credentials.css';
import { UUID } from '@/types';

const _FinishButton: TrevorComponent<{
  firstTimeSetup: boolean;
  datasourceId: UUID;
}> = ({ className, firstTimeSetup, datasourceId }) => {
  const finishButtonText = firstTimeSetup ? 'Continue' : 'Finish';

  // TODO: this is a temporary soluition. Ideally we just invalidate RTK Queries and refetch.
  const handleClick = (e: React.MouseEvent) => {
    if (!firstTimeSetup) {
      e.preventDefault();
      window.open(`/datasources/${datasourceId}`, '_self');
    }
  };

  return (
    <div className={className}>
      <Link
        to={`/datasources/${datasourceId}`}
        onClick={handleClick}
        id="next-database-added"
      >
        <Button className={style.done}>{finishButtonText}</Button>
      </Link>
    </div>
  );
};

export const FinishButton = styled(_FinishButton)`
  margin-top: 30px;
  display: flex;
  justify-content: center;
`;
